import { createFileRoute } from '@tanstack/react-router';

import {
  paymentsReportQueryOptions,
  PaymentsReportPage,
  resolveRange,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/payments')({
  staticData: { crumb: 'reports:tabs.payments', tours: ['reports.payments'] },
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...paymentsReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: PaymentsReportPage,
});
